import React, {useState} from 'react';
import * as S from './AisProfileListItem.styles';
import scrollIntoView from 'scroll-into-view-if-needed';
import {INavBarItem} from '../../../../../shared/types/aisProfile';
import classNames from 'classnames';
const AisProfileListItem: React.FC<INavBarItem> = props => {
  const {isActive, itemText, itemImage, keyToRefer, handleOnClick} = props;

  const [isActiveState, setIsActiveState] = useState(isActive);
  const getId = () => {
    scrollIntoView(document.getElementById(props?.keyToRefer), {
      block: props?.keyToRefer,
      behavior: 'smooth',
    });
    handleOnClick && handleOnClick(keyToRefer);
  };

  return (
    <S.ListItem>
      {
        <li
          className={`profileListItem ${isActive ? 'active' : ' '}`}
          onClick={() => {
            getId();
          }}
        >
          <span
            className={`appendRight12 ${classNames(itemImage?.data?.styles?.iconClasses)}`}
          ></span>
          <span className={``}>{itemText?.data?.primaryText}</span>
        </li>
      }
    </S.ListItem>
  );
};

export default AisProfileListItem;
